import { IMAGES } from '../mock';

export default function Showcase() {
  return (
    <section className="relative w-full h-[65vh] min-h-[500px] max-h-[720px] overflow-hidden">
      {/* Background image */}
      <img
        src={IMAGES.hallway}
        alt="Refurbished hallway with heritage brick and exposed timber trusses"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Dark gradient overlay for legibility */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(90deg, rgba(13,40,30,0.75) 0%, rgba(13,40,30,0.35) 45%, rgba(13,40,30,0) 70%)',
        }}
      />

      {/* Caption content */}
      <div className="relative z-10 h-full max-w-[1400px] mx-auto px-6 md:px-10 flex items-center">
        <div className="max-w-lg text-[#f1ede5]">
          <span className="eyebrow">Craftsmanship</span>
          <h2 className="font-serif-display text-[42px] md:text-[54px] leading-[1.05] mt-6">
            Heritage details,<br />
            <em className="text-[#b39352] italic">modern craft.</em>
          </h2>
          <p className="mt-6 text-[14px] leading-[1.85] text-[#f1ede5]/85 max-w-md">
            Herringbone timber floors, restored brickwork and exposed roof trusses meet
            contemporary glazing and considered lighting throughout every suite.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
            <div>
              <div className="font-serif-display text-[36px] text-[#b39352] leading-none">11</div>
              <div className="text-[10px] tracking-[0.22em] uppercase text-[#f1ede5]/75 mt-2">Units in total</div>
            </div>
            <div>
              <div className="font-serif-display text-[36px] text-[#b39352] leading-none">£1m+</div>
              <div className="text-[10px] tracking-[0.22em] uppercase text-[#f1ede5]/75 mt-2">Invested in works</div>
            </div>
            <div>
              <div className="font-serif-display text-[36px] text-[#b39352] leading-none">B/C+</div>
              <div className="text-[10px] tracking-[0.22em] uppercase text-[#f1ede5]/75 mt-2">EPC rating</div>
            </div>
          </div>
        </div>
      </div>

      {/* Gold underline */}
      <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-[#b39352]" />
    </section>
  );
}
